import { atom, selector, useRecoilState, useResetRecoilState } from 'recoil';

import {
  setLoginInform,
  resetLoginInform,
  getLoginInform
} from 'function/login';
import isEmpty from 'utils/isEmpty';

/**
 * 로그인 정보
 */
// atom
const loginState = atom({
  key: 'loginState',
  default: {},
  effects: [
    ({ setSelf, onSet }) => {
      setSelf(() => getLoginInform());
      onSet(newState => {
        if (isEmpty(newState)) {
          resetLoginInform();

          return;
        }

        setLoginInform(newState);
      });
    }
  ]
});

// selector
const loginSelector = selector({
  key: 'loginSelector',
  get: ({ get }) => get(loginState),
  set: ({ set }, newValue) =>
    set(loginState, prevState => ({ ...prevState, ...newValue }))
});

// hook
function useLoginState() {
  const [login, setLogin] = useRecoilState(loginSelector);
  const resetLogin = useResetRecoilState(loginState);

  return {
    login,
    setLogin,
    resetLogin
  };
}

export default useLoginState;
